module.exports = __webpack_public_path__ + "static/media/Instagram.4ec02ff0.svg";